/*
 * @Author: hl
 * @Date: 2022-12-22 09:00:17
 * @LastEditors: hl
 * @LastEditTime: 2023-01-14 16:39:08
 */
import { apiPost, apiGet } from "@/static/js/request";
//福利币测试服域名


/** 支付查询 */
export function rechargeOrderPay(params) {
  return apiGet({
      url: "/api/recharge/order",
      params
  })
}

// 获取新人福利活动信息
export function currencyNewplayerActivity(params) {
  return apiGet({
    url: "/api/platform/currency/new/player/activity",
    params
  })
}

// 领取新人福利红包
export function getCurrencyNewplayerActivity(params) {
  return apiPost({
    url: "/api/platform/currency/new/player/activity/get",
    params
  })
}

//购买新人福利-一元解锁
export function buyCurrencyNewplayerActivity(params) {
  return apiPost({
    url: '/api/platform/currency/new/player/activity/buy',
    params
  })
}
// 领取 1.3元
export function withdrawActivityXinr(params) {
  return apiPost({
    url: '/api/platform/currency/new/player/activity/withdraw',
    params
  })
}


// 福利币信息
export function taiwanDollarInformation(params) {
  return apiGet({
    url: "/api/platform/currency",
    params
  })
}


// 福利币消耗列表
export function consumptionList(params) {
  return apiGet({
    url: "/api/platform/currency/list/log",
    params
  })
}
//兑换码兑换福利币
export function redeemCode(params) {
  return apiPost({
    url: '/api/box/drainage/getCode',
    params
  })
}


// cdk码兑换福利币
// /api/platform/currency/cdk/exchange
export function currencyexchangemoney(params) {
  return apiPost({
    url: "/api/platform/currency/cdk/exchange",
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/currency/index.js